export const selectDepartments = (state) =>
  state.companyDepartment?.departments || [];
export const selectDepartmentLoading = (state) =>
  state.companyDepartment?.loading || false;
export const selectDepartmentError = (state) =>
  state.companyDepartment?.error || null;
export const selectSelectedDepartment = (state) =>
  state.companyDepartment?.selectedDepartment || null;
